import $ from 'jquery';
import 'slick-carousel';

export default class ContentSliderHalf {
    constructor() {
        var $status = $('.pagingInfo');
        
        $('.content-50-slider-50__slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });

        $('.content-50-slider-50__slider').slick({
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: $('.content-50-slider-50__arrows__prev-arrow'),
            nextArrow: $('.content-50-slider-50__arrows__next-arrow')
        });
    }
}
new ContentSliderHalf();